import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { shippingApi } from '../api/shippingApi';
import { useSupplierAuth } from '../contexts/SupplierAuthContext';

const SupplierLoginPage = () => {
  const { login } = useSupplierAuth();
  const [supplierCode, setSupplierCode] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await shippingApi.supplierLogin(
        parseInt(supplierCode),
        password
      );
      
      // 認証コンテキストに保存
      const supplierName = response.supplier_name || response.data?.supplier_name || `仕入先${supplierCode}`;
      const sessionToken = response.session_token || response.data?.session_token;
      
      if (!sessionToken) {
        throw new Error('セッショントークンが取得できませんでした');
      }
      
      login(
        parseInt(supplierCode),
        sessionToken,
        supplierName
      );
      
      // 編集ページにリダイレクト
      navigate('/supplier-share-edit');
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'ログインに失敗しました');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h1 className="text-2xl font-semibold text-slate-900 mb-6 text-center">
          仕入先ログイン
        </h1>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="supplierCode" className="block text-sm font-medium text-slate-700 mb-2">
              仕入先コード
            </label>
            <input
              id="supplierCode"
              type="number"
              value={supplierCode}
              onChange={(e) => setSupplierCode(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-500 text-slate-900"
              required
              disabled={loading}
            />
          </div>
          
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-2">
              パスワード
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-500 text-slate-900"
              required
              disabled={loading}
            />
          </div>
          
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm">
              {error}
            </div>
          )}
          
          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-2 bg-slate-700 text-white rounded-md hover:bg-slate-800 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SupplierLoginPage;
